import Vue from 'vue'
import App from './topicPage.vue'
import ajax from '../../assets/js/axios.config';
import utils from '../../utils/utils';
import bussiness from '../../assets/js/bussiness';
import Velocity from 'velocity-animate';
import toast from '../../components/Toast';
import loading from '../../components/Loading';

import 'lib-flexible'
import '../../assets/css/comm.css'
import '../../assets/scss/main.scss'

var gsAppJsApi = document.createElement("script");
gsAppJsApi.src = "https://j.gamersky.com/g/gsAppJsApi.js?20220722";
document.body.appendChild(gsAppJsApi);
gsAppJsApi.onload = () => {
    Vue.use(toast);
    Vue.use(loading);
    Vue.config.productionTip = false;
    Vue.prototype.$ajax = ajax;
    Vue.prototype.$utils = utils;
    Vue.prototype.$bussiness = bussiness;
    Vue.prototype.$Velocity = Velocity;

    new Vue({
        render: h => h(App),
    }).$mount('#app')
};